import apiClient from "../api";

export const createPrivateTransaction = async (transactionData) => {
  try {
    // Créer FormData pour gérer les fichiers
    const formData = new FormData();
    
    // Fonction helper pour ajouter les données
    const appendFormData = (key, value) => {
      if (value !== null && value !== undefined && value !== '') {
        formData.append(key, value.toString());
      }
    };
    
    // ==================== CHAMPS OBLIGATOIRES ====================
    appendFormData('SecurityId', transactionData.securityId);
    appendFormData('Quantity', transactionData.quantity);
    appendFormData('DomainId', transactionData.domainId);
    appendFormData('TransactionType', transactionData.transactionType);
    appendFormData('AccountCategory', transactionData.accountCategory);
    
    // ==================== DATES (format ISO) ====================
    if (transactionData.dateOperation) {
      const dateOp = new Date(transactionData.dateOperation);
      formData.append('DateOperation', dateOp.toISOString());
    }
    
    if (transactionData.dateCredit) {
      const dateCr = new Date(transactionData.dateCredit);
      formData.append('DateCredit', dateCr.toISOString());
    }
    
    // ==================== CHAMPS OPTIONNELS ====================
    if (transactionData.operationNature) {
      appendFormData('OperationNature', transactionData.operationNature);
    }
    
    if (transactionData.fromAccountId) {
      appendFormData('FromAccountId', transactionData.fromAccountId);
    }
    
    if (transactionData.toAccountId) {
      appendFormData('ToAccountId', transactionData.toAccountId);
    }
    
    if (transactionData.fromAccountCategory) {
      appendFormData('FromAccountCategory', transactionData.fromAccountCategory);
    }
    
    if (transactionData.conversionSecurityId) {
      appendFormData('ConversionSecurityId', transactionData.conversionSecurityId);
    }
    
    // ==================== DOCUMENTS (CRITIQUE) ====================
    // CORRECTION : Ajouter chaque fichier individuellement avec le même nom de clé
    if (transactionData.documents && Array.isArray(transactionData.documents) && transactionData.documents.length > 0) {
      // console.log(`📎 Ajout de ${transactionData.documents.length} documents au FormData`);
      
      // Chaque fichier doit être ajouté avec la clé "Documents" (PAS Documents[0], Documents[1], etc.)
      transactionData.documents.forEach((file) => {
        formData.append('Documents', file, file.name);
        // console.log(`✅ Document ajouté: ${file.name} (${file.size} bytes)`);
      });
    }
    
    // DEBUG : Afficher le contenu du FormData
    // console.log('📦 Contenu du FormData:');
    // for (let [key, value] of formData.entries()) {
    //   if (value instanceof File) {
    //     console.log(`  ${key}: [File] ${value.name} (${value.size} bytes)`);
    //   } else {
    //     console.log(`  ${key}: ${value}`);
    //   }
    // }
    
    // ==================== ENVOI DE LA REQUÊTE ====================
    const response = await apiClient.post('/api/Transactions/prive', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      // IMPORTANT : Ne pas mettre de transformRequest
      transformRequest: [(data) => data]
    });
    
    // console.log('✅ Réponse API:', response.data);
    return response.data;
    
  } catch (error) {
    // console.error('❌ Erreur complète:', error);
    
    if (error.response?.status === 400) {
      const errorMessage = error.response.data?.message || 
                          error.response.data?.errors ? 
                            Object.values(error.response.data.errors).flat().join(', ') :
                            'Validation échouée';
      throw new Error(errorMessage);
    }
    
    if (error.response?.status === 401 || error.response?.status === 403) {
      throw new Error('Vous n\'êtes pas autorisé à effectuer cette opération');
    }
    
    if (error.response?.status === 500) {
      const serverError = error.response.data?.message || 
                         error.response.data?.details || 
                         'Erreur serveur. Veuillez réessayer plus tard.';
      throw new Error(serverError);
    }
    
    throw new Error(error.response?.data?.message || error.message || 'Erreur lors de la création de la transaction');
  }
};
// Récupérer les catégories de compte disponibles
export const getAccountCategories = async () => {
  try {
    // Si vous avez une API, utilisez-la
    // const response = await apiClient.get('/api/account-categories');
    // return response.data;
    
    // Pour l'instant, retournez les catégories statiques
    return [
      { code: 'NOMP', label: 'Nominatif Pur', description: 'Compte nominatif standard' },
      { code: 'CEPO', label: 'Émission Porteur', description: 'Émission au porteur' },
      { code: 'CENO', label: 'Émission Nominatif', description: 'Émission nominative' },
      { code: 'CGEM', label: 'Global d\'Émission', description: 'Compte global d\'émission' },
      { code: 'PORT', label: 'au Porteur', description: 'Compte au porteur' },
      { code: 'NOCH', label: 'Nominatif Changé', description: 'Nominatif changé' },
      { code: 'NPRO', label: 'Nominatif Propre', description: 'Nominatif propre' },
      { code: 'NOAD', label: 'Nominatif Administrateur', description: 'Nominatif administrateur' },
      { code: 'NADC', label: 'Nominatif Administrateur Changé', description: 'Nominatif administrateur changé' },
      { code: 'TIAN', label: 'Titre à Annuler', description: 'Titres en attente d\'annulation' },
      { code: 'TRNE', label: 'Transit', description: 'Compte de transit' },
      { code: 'TIRE', label: 'Titre Rendu', description: 'Titres rendus' },
      { code: 'GETR', label: 'Gestion de Titres', description: 'Compte de gestion' },
      { code: 'TNAF', label: 'Titre Non Affecté', description: 'Titres non affectés' },
      { code: 'TARE', label: 'Titre Affecté', description: 'Titres affectés' },
      { code: 'TALI', label: 'Titre Aliéné', description: 'Titres aliénés' },
      { code: 'REGU', label: 'Régularisation', description: 'Compte de régularisation' }
    ];
  } catch (error) {
    // console.error('Erreur récupération catégories:', error);
    throw new error;
  }
};

// Récupérer les titres pour conversion
export const getConversionSecurities = async (securityId) => {
  try {
    const response = await apiClient.get(`/api/securities/conversion/${securityId}`);
    return response.data;
  } catch (error) {
    // console.error('Erreur récupération titres conversion:', error);
    return [];
  }
};

// Ajoutez cette fonction pour récupérer le résumé des transactions privées
export const getPrivateTransactionsSummary = async (domainId) => {
  try {
    const response = await apiClient.get(
      `/api/Dashboard/private-transactions/summary`,
      { params: { domainId } }
    );
    // console.log('Résumé des transactions privées:', response.data);
    return response.data;
  } catch (error) {
    // console.error("Erreur lors de la récupération du résumé des transactions privées:", error);
    throw new error;
  }
};